import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import avatarPro from "assets/img/Share-Safari/dpinterested.png";
import { useEffect } from "react";

function InterestesUserModal() {
  const { instUserToggle, intreastedUsers, sharedSafariDispatch } =
    useSharedSafariContext();

    useEffect(() => {

}, [intreastedUsers]);


  const handleClose = () => {
    sharedSafariDispatch({
      type: "SET_SHARED_SAFARI_VIEW_USERS_TOGGLE",
      payload: false,
    });
  };
  

  return (
    <Modal show={instUserToggle} size="xl" onHide={handleClose} centered>
      <Modal.Header className="p-2">
        <h2 className="modal-title fs-5" id="exampleModalLabel">
          Interest
        </h2>
        <button
          onClick={handleClose}
          className="bg-transparent"
          style={{
            border: "none",
            color: "#fff",
            fontSize: "26px",
            fontWeight: "900",
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="grid-view">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Join At</th>
              </tr>
            </thead>
            <tbody>
              {intreastedUsers?.map((user, index) => (
                <tr key={user.id}>
                  <td style={{ width: "10%" }}>{index + 1}</td>
                  <td>
                    <Link
                      to={`/profile/default/index?user_handle=${user.user_handle}`}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <Image
                          src={user?.profile_display_image || avatarPro}
                          alt="user"
                          className="rounded-circle"
                          width={30}
                          height={30}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = avatarPro;
                          }}
                        />
                        { user.name || "Unknown User"}
                      </div>
                    </Link>
                  </td>

                  <td style={{ width: "20%" }}>
                    {user.created_at
                      ? new Date(user.created_at).toLocaleDateString()
                      : "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="summary">
            Showing <b>1</b> - <b>{intreastedUsers.length}</b> of{" "}
            <b>{intreastedUsers.length}</b> interested users
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default InterestesUserModal;
